// Mirrors flutter_client VehicleType.fromRateId() + uk.json labels.
const TARIFFS_BY_RATE_ID: Record<string, { nameUk: string; nameEn: string; order: number }> = {
  '78235900-0ce1-4aca-99ca-b89e776f0910': { nameUk: 'Стандарт', nameEn: 'Standard', order: 2 },
  'b4c9b252-8d90-400c-bab8-c21f4fd9c7a9': { nameUk: 'Комфорт', nameEn: 'Comfort', order: 3 },
  'bdf73206-ed08-4aec-b603-40ee948c53b2': { nameUk: 'Бізнес', nameEn: 'Business', order: 4 },
  'b087c62a-2a61-404a-8bfe-f42e2c4977db': { nameUk: 'Універсал', nameEn: 'Station wagon', order: 5 },
  '47c82a56-cd4a-48a1-be00-03e0ae9dcef9': { nameUk: 'Мінівен', nameEn: 'Minivan', order: 6 },
  '3e494510-87b2-4a54-b32e-f321b375eb84': { nameUk: 'Базовий', nameEn: 'Base', order: 1 },
};

export function getTariffName(rateId: string, language = 'uk'): string {
  const tariff = TARIFFS_BY_RATE_ID[rateId];
  if (!tariff) return language === 'uk' ? 'Базовий' : 'Base';
  return language === 'uk' ? tariff.nameUk : tariff.nameEn;
}

export function getTariffOrder(rateId: string): number {
  return TARIFFS_BY_RATE_ID[rateId]?.order ?? 99;
}
